import { render, staticRenderFns } from "./CountryNew.vue?vue&type=template&id=3acd153a&scoped=true&"
import script from "./CountryNew.vue?vue&type=script&lang=js&"
export * from "./CountryNew.vue?vue&type=script&lang=js&"
import style0 from "./CountryNew.vue?vue&type=style&index=0&id=3acd153a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acd153a",
  null
  
)

export default component.exports